export default {
  name: "dr-input",
  props: {
    label: {
      type: String
    }
  },
  computed: {
    inputListeners: function() {
      var vm = this;

      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit("input", event.target.value);
        }
      });
    }
  }
};
